import { schema } from 'normalizr';

export const paymentSetupSchema = new schema.Entity('paymentSetup');
